import { render, staticRenderFns } from "./IconMatch.vue?vue&type=template&id=1ba0e25a"
import script from "./IconMatch.vue?vue&type=script&lang=js"
export * from "./IconMatch.vue?vue&type=script&lang=js"
import style0 from "./IconMatch.vue?vue&type=style&index=0&id=1ba0e25a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports